import type { OutputFormat } from '../lib/api';

interface Props {
  format: OutputFormat;
  onFormatChange: (format: OutputFormat) => void;
  quality: number;
  onQualityChange: (quality: number) => void;
  disabled?: boolean;
}

export function OptionsBar({ format, onFormatChange, quality, onQualityChange, disabled }: Props) {
  return (
    <div className="options">
      <div className="field">
        <span className="field-label" id="format-label">
          Convert to
        </span>
        <div className="segmented" role="group" aria-labelledby="format-label">
          <button
            type="button"
            aria-pressed={format === 'jpeg'}
            disabled={disabled}
            onClick={() => onFormatChange('jpeg')}
          >
            JPG
          </button>
          <button
            type="button"
            aria-pressed={format === 'png'}
            disabled={disabled}
            onClick={() => onFormatChange('png')}
          >
            PNG
          </button>
        </div>
      </div>

      {format === 'jpeg' ? (
        <div className="field">
          <label className="field-label" htmlFor="quality">
            Quality
          </label>
          <input
            id="quality"
            className="slider"
            type="range"
            min={40}
            max={100}
            step={1}
            value={quality}
            disabled={disabled}
            onChange={(event) => onQualityChange(Number(event.target.value))}
          />
          <span className="quality-value">{quality}</span>
        </div>
      ) : (
        <div className="field">
          <span className="field-label">PNG is lossless, so there is no quality setting.</span>
        </div>
      )}
    </div>
  );
}
